<template>
  <div class='why' @mouseleave="mouseOutHandle">
    <div class='why-inner'>
      <h2>{{moduleData.title}}</h2>
      <p class='subtitle' v-if="moduleData.subTitle" :style="{color: `${moduleData.color}`}">{{moduleData.subTitle}}</p>
      <img class='bg1' :src="moduleData.bg1" v-if="moduleData.bg1">
      <img class='bg2' :src="moduleData.bg2" v-if="moduleData.bg2">
      <div class='why-image'>
        <img :src="moduleData.image" border="0" usemap="#planetmap" alt="Planets" />
        <map name="planetmap" id="planetmap">
          <area shape="rect" coords="216,21,332,171" @mouseover="mouseOverHandle('member')" @mousemove="mouseMoveHandle('member')"  alt="会员服务"/>
          <area shape="rect" coords="20,120,192,250" @mouseover="mouseOverHandle('bigData')" @mousemove="mouseMoveHandle('bigData')" alt="数据智能服务"/>
          <area shape="rect" coords="120,300,156,443" @mouseover="mouseOverHandle('finance')" @mousemove="mouseMoveHandle('finance')"  alt="金融服务"/>
          <area shape="rect" coords="638,43,764,183" @mouseover="mouseOverHandle('dfw')" @mousemove="mouseMoveHandle('dfw')"  alt="育儿&成长服务"/>
          <area shape="rect" coords="792,142,915,287" @mouseover="mouseOverHandle('wuliu')" @mousemove="mouseMoveHandle('wuliu')"  alt="物流服务"/>
          <area shape="rect" coords="685,329,840,640" @mouseover="mouseOverHandle('market')" @mousemove="mouseMoveHandle('market')"  alt="全域营销服务"/>
        </map>
        <div class='why-popover' :style="{top: `${curModule.top}`,left: `${curModule.left}`, width: `${curModule.width}`}" v-show="show">
          <div class='why-popover-inner' :class='curModule.classname'>
            <div class='why-popover-data' v-for="(item, idx) in curModuleData" :key="idx">
              <h4>{{item.name}}</h4>
              <p>{{item.desc}}</p>
              <a :href="item.link" v-if="item.link">了解更多></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
      moduleData: {
        type: Object,
        default: () => {}
      },
      popdata: {
        type: Array,
        default: () => []
      },
      height: {
        type: String,
        default: ''
      }  
  },
  data() {
    return {
      show: false,
      curModule: {},
      curModuleData: [],
    }
  },
  methods: {
    getCurrentModuleData(moduleName) {
      return this.popdata.filter(x => x.key === moduleName)
    },
    getCurrentModule(moduleName) {
      return this.popdata.find(x => x.key === moduleName)
    },
    mouseMoveHandle(moduleName) {
      this.curModule = this.getCurrentModule(moduleName)
      this.curModuleData = this.getCurrentModuleData(moduleName)
      this.show = true
    },
    mouseOverHandle(moduleName) {
      this.curModule = this.getCurrentModule(moduleName)
      this.curModuleData = this.getCurrentModuleData(moduleName)
      this.show = true
    },
    mouseOutHandle(e) {
      this.curModule = {}
      this.curModuleData = []
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.why{
  height: 640px;
  position: relative;
  background-color: #fff;
  // background-repeat: no-repeat;
  // background-position: left 311px;
  // background-size: 10%;
  .why-inner{
    position: relative;
    height: 640px;
    @include Flex;
    flex-direction: column;
    align-items: center;
    // background-repeat: no-repeat;
    // background-position: right 43px;
    // background-size: 10%;
  }

  .bg1,.bg2{
    position: absolute;
    width:299px;
    height: 294px;
  }
  .bg1{
    left:0;
    bottom: 43px;
    z-index: 0;
  }
  .bg2{
    right:0;
    top: 43px;
    z-index:0;
  }

  h2 {
    padding-top: 72px;
    padding-bottom: 16px;
    font-size: 30px;
    line-height: 1;
    font-weight: bold;
    color: #010101;
  }

  .subtitle{
    font-size: 14px;
    color: #505050;
  }
  .why-image{
    position: relative;
    padding-top: 15px;

    area{
      cursor:pointer;
    }
  }
  .why-popover{
    position: absolute;
    width: 357px;
    // height: 158px;
    background-repeat: no-repeat;
    background-size: contain;
    color: #fff;
    transition: all 0.2s;
    border-radius:10px;
    background:linear-gradient(to right,#6633cc, #3333cc);

    .why-popover-inner{
      width: 100%;
      height: 100%;
      padding: 20px;
      position: relative;


      &.leftBottom{
      &::before{
          bottom: -40px;
          left: 50px;
          border-color: #6633cc transparent transparent;
      }
    }

    &.rightBottom{
      &::before{
          bottom: -40px;
          right: 50px;
          border-color: #3333cc transparent transparent;
      }
    }

    &.rightTop{
      &::before{
          border-width: 0 10px 20px;
          top: -20px;
          right: 50px;
          border-color:#3333cc transparent ;
      }
    }

    &.leftTop{
      &::before{
          border-width: 0 10px 20px;
          top: -20px;
          left: 50px;
          border-color:#6633cc transparent ;
      }
    }

    &.left{
      &::before{
          border-width: 10px 20px 10px 0;;
          top: 20px;
          left: -20px;
          border-color:transparent #6633cc;
      }
    }

    &.right{
      &::before{
          border-width: 10px 0 10px 20px;
          top: 20px;
          right: -20px;
          border-color:transparent #3333cc;
      }
    }

    &::before{
      content: '';
			width: 0;
			height: 0;
      border-width: 20px 10px;
			border-style: solid;
			position: absolute;
    }
    }

    
    .why-popover-data:not(:first-child){
      padding-top:10px;
    }

    h4{
      color: #fff;
      font-size: 16px;
      padding-bottom: 8px;
      line-height: 1;
    }
    p{
      font-size: 12px;
      padding-bottom: 8px;
      // line-height: 1.3;
    }

    a{
      color: #fff;
      font-size: 12px;
    }
  }
  .dfw{
    width:410px;
    height: 238px;
  }
  .member, .dfw{
    padding-top: 40px;
  }
  .bigData, .wuliu{
    padding-bottom: 40px;
  }
  .finance{
    padding-left: 40px;
  }
  .market{
    padding-right: 40px;
  }
}
</style>
